export class UpdateOrganizationAbcpDto {
    id: string;
    enabled: boolean;
}
